<template>
  <ModalWrapperComponent dialog-name="MoveMySubscriptionComponent" :show-dialog="showDialog" @close-modal="closeModal">
    <template #header>
      {{ tn("headerH1") }}
    </template>
    <template #content>
      <ul>
        <li>
          {{ tn("macToMacLine1") }}
          <strong>{{ nickname }}</strong>
        </li>
        <li>
          {{ tn("macToMacLine2") }}
        </li>
        <li>
          <i18n-t keypath="MacToMacMoveSubscriptionComponent.macToMacLine3" tag="p" scope="global">
            <template #Continue>
              <strong>{{ tn("footerButtonContinue") }}</strong>
            </template>
            <template #nickname>
              <strong>{{ nickname }}</strong>
            </template>
          </i18n-t>
        </li>
      </ul>
    </template>
    <template #footer>
      <button id="btnCancelChangesMacToMac" type="button" class="btn-link mr-half" @click="closeModal()">
        {{ tn("footerButtonCancel") }}
      </button>
      <button id="btnSaveChangesMacToMac" type="button" class="btn-primary" @click="handleSaveModal()">
        {{ tn("footerButtonContinue") }}
      </button>
    </template>
  </ModalWrapperComponent>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from "vue";
import { logEvent } from "@/common/logger";
import { t } from "@/i18n";
import { IDevice } from "@/common/api/unifiedPortal/interfaces";
import ModalWrapperComponent from "@/components/shared/dialogs/ModalWrapper.vue";

const componentName = "MacToMacMoveSubscriptionComponent";

export default defineComponent({
  name: componentName,
  components: { ModalWrapperComponent },
  props: {
    device: {
      type: Object as PropType<IDevice>,
      required: true,
    },
    showDialog: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["save", "cancel"],

  setup(props, context) {
    logEvent("created", componentName, props.device);
    const nickname = ref<string>(props.device.description);

    function tn(v: string, params?: Record<string, unknown>): string {
      return t(`${componentName}.${v}`, params);
    }

    function handleSaveModal() {
      logEvent("Save move sub", componentName, "Reinstall");
      context.emit("save", "Reinstall");
    }

    function closeModal() {
      logEvent("Close move sub", componentName);
      context.emit("cancel");
    }

    //Expose to template
    return {
      tn,
      nickname,
      handleSaveModal,
      closeModal,
    };
  },
});
</script>

<style scoped lang="css">
@import "@/styles/variables.css";
</style>
